import React from 'react';
import WaiseInterface from '../WaiseInterface';
import WaiseV2Interface from './WaiseV2Interface';
import WaiseV2Boundary from './WaiseV2Boundary';
import { isRemoteCloudHost } from '../../utils/cloudBrowserSession';

// Legacy URLs remain available locally. Cloud writes must use the interface
// that carries the displayed snapshot; never show an unprotected old editor.
export default function WaiseLegacyPage() {
  return isRemoteCloudHost(window.location.hostname) ? <WaiseV2Boundary><WaiseV2Interface /></WaiseV2Boundary> : <WaiseInterface />;
}
